import { cn } from 'lib/helpers/utility';

const StatusInfoCell = ({ status }) => {
  return (
    <div className="flex h-full w-full items-center">
      <div
        className={cn(
          'flex h-full max-h-5 w-fit items-center justify-center rounded-md px-1.5 text-xs text-neutral-900',
          status
            ? 'border border-solid border-success-200 bg-success-100'
            : 'border border-solid border-danger-200 bg-danger-100'
        )}>
        {status ? 'Active' : 'Inactive'}
      </div>
    </div>
  );
};

export default StatusInfoCell;
